// store/sagas/index.ts
import { all, fork } from "redux-saga/effects";
import productsRootSaga from "@/store/sagas/productNew.saga";
import CategoriesRootSaga from "@/store/sagas/category.saga";
import collectionsRootSaga from "@/store/sagas/collection.saga";
import dashboardRootSaga from "@/store/sagas/dashboard.saga";
import { couponSaga } from "@/store/sagas/coupon.saga";
import { orderSaga } from "@/store/sagas/order.saga";
import inventoryRootSaga from "./inventory.saga";
import { authSaga } from "./auth.sagas";
import { kycSaga } from "./kyc.saga";
import pagesRootSaga from "./page.saga";
import assetsRootSaga from "@/store/sagas/assets.saga";
import uiRootSaga from "@/store/sagas/ui.saga";
import rootWebBuilderSaga from "./webbuilderSaga";
import taxSaga from "./tax.saga";
import sseRootSaga from "./sse.saga";
import ticketsRootSaga from "./ticket.saga";
import customersRootSaga from "./customer.saga";
import chargeRootSaga from "./charge.saga";
import marketingCampaignSaga from "./marketingCampaign.saga";
import marketingAutomationSaga from "./marketingAutomation.saga";
import abandonedCartSaga from "./abandonedCart.saga";
import marketingTemplateSaga from "./marketingTemplate.saga";
import { metafieldSaga } from "./metafield.saga";
import { domainSaga } from "./domain.saga";
import { subscriptionSaga } from "./subscription.saga";
import permissionSaga from "./permission.saga";
import pickupLocationSaga from "./pickupLocation.saga";

export default function* rootSaga() {
  yield all([
    fork(productsRootSaga),
    fork(CategoriesRootSaga),
    fork(collectionsRootSaga),
    fork(couponSaga),
    fork(orderSaga),
    fork(inventoryRootSaga),
    fork(authSaga),
    fork(kycSaga),
    fork(pagesRootSaga),
    fork(assetsRootSaga),
    fork(uiRootSaga),
    fork(rootWebBuilderSaga),
    fork(taxSaga),
    fork(sseRootSaga),
    fork(ticketsRootSaga),
    fork(customersRootSaga),
    fork(dashboardRootSaga),
    fork(chargeRootSaga),
    fork(marketingCampaignSaga),
    fork(marketingAutomationSaga),
    fork(abandonedCartSaga),
    fork(marketingTemplateSaga),
    fork(metafieldSaga),
    fork(domainSaga),
    fork(subscriptionSaga),
    fork(permissionSaga),
    fork(pickupLocationSaga),
  ]);
}
